"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.APIRequestContextSchema = exports.RateLimitHeadersSchema = exports.SubscriptionEndpointsSchema = exports.CommunityEndpointsSchema = exports.UserEndpointsSchema = exports.AuthEndpointsSchema = exports.FactCheckEndpointsSchema = exports.SystemStatusResponseSchema = exports.HealthCheckResponseSchema = exports.APIVersionSchema = void 0;
const zod_1 = require("zod");
// Base API endpoint types
exports.APIVersionSchema = zod_1.z.enum(['v1']);
// Health Check Response
exports.HealthCheckResponseSchema = zod_1.z.object({
    status: zod_1.z.enum(['healthy', 'degraded', 'unhealthy']),
    timestamp: zod_1.z.string().datetime(),
    version: zod_1.z.string(),
    services: zod_1.z.object({
        database: zod_1.z.enum(['healthy', 'degraded', 'unhealthy']),
        redis: zod_1.z.enum(['healthy', 'degraded', 'unhealthy']),
        claude: zod_1.z.enum(['healthy', 'degraded', 'unhealthy']),
        gemini: zod_1.z.enum(['healthy', 'degraded', 'unhealthy']),
    }),
    responseTime: zod_1.z.number(),
});
// System Status Response
exports.SystemStatusResponseSchema = zod_1.z.object({
    status: zod_1.z.enum(['operational', 'degraded', 'major_outage']),
    timestamp: zod_1.z.string().datetime(),
    metrics: zod_1.z.object({
        totalRequests: zod_1.z.number(),
        avgResponseTime: zod_1.z.number(),
        errorRate: zod_1.z.number(),
        cacheHitRate: zod_1.z.number(),
        activeUsers: zod_1.z.number(),
    }),
    costs: zod_1.z.object({
        dailySpendCents: zod_1.z.number(),
        monthlySpendCents: zod_1.z.number(),
        avgCostPerCheck: zod_1.z.number(),
    }).optional(), // Only for admin users
});
// Fact Check Endpoints
exports.FactCheckEndpointsSchema = zod_1.z.object({
    post: zod_1.z.literal('/fact-check'),
    get: zod_1.z.literal('/fact-check/:id'),
    history: zod_1.z.literal('/fact-checks'),
});
// Auth Endpoints
exports.AuthEndpointsSchema = zod_1.z.object({
    socialLogin: zod_1.z.literal('/auth/social-login'),
    refresh: zod_1.z.literal('/auth/refresh'),
    logout: zod_1.z.literal('/auth/logout'),
});
// User Endpoints
exports.UserEndpointsSchema = zod_1.z.object({
    profile: zod_1.z.literal('/user/profile'),
    preferences: zod_1.z.literal('/user/preferences'),
    usage: zod_1.z.literal('/user/usage'),
    reputation: zod_1.z.literal('/user/reputation'),
});
// Community Endpoints
exports.CommunityEndpointsSchema = zod_1.z.object({
    posts: zod_1.z.literal('/community/posts'),
    createPost: zod_1.z.literal('/community/posts'),
    userProfile: zod_1.z.literal('/community/users/:id'),
    badges: zod_1.z.literal('/community/badges'),
});
// Subscription Endpoints
exports.SubscriptionEndpointsSchema = zod_1.z.object({
    create: zod_1.z.literal('/subscription/create'),
    update: zod_1.z.literal('/subscription/update'),
    cancel: zod_1.z.literal('/subscription/cancel'),
    webhook: zod_1.z.literal('/subscription/webhook'),
});
// Rate Limiting Headers
exports.RateLimitHeadersSchema = zod_1.z.object({
    'x-rate-limit-limit': zod_1.z.string(),
    'x-rate-limit-remaining': zod_1.z.string(),
    'x-rate-limit-reset': zod_1.z.string(),
    'x-rate-limit-window': zod_1.z.string(),
});
// API Request Context (for internal use)
exports.APIRequestContextSchema = zod_1.z.object({
    requestId: zod_1.z.string(),
    userId: zod_1.z.string().optional(),
    userAgent: zod_1.z.string().optional(),
    ipAddress: zod_1.z.string().optional(),
    platform: zod_1.z.enum(['web', 'ios', 'android', 'extension']).optional(),
    timestamp: zod_1.z.string().datetime(),
});
//# sourceMappingURL=api.js.map